
import { useNavigate } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ShieldAlert, LogIn, Home, ArrowLeft } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const Unauthorized = () => {
  const navigate = useNavigate();
  const { user, userRoles, signOut } = useAuth();

  return (
    <Layout>
      <div className="flex flex-col items-center justify-center min-h-[70vh] px-4 text-center">
        <Card className="max-w-md p-8 shadow-lg">
          <ShieldAlert className="h-20 w-20 text-red-500 mx-auto mb-4" />
          <h1 className="text-3xl font-bold mb-4">Access Denied</h1>
          <p className="text-lg text-gray-600 mb-6">
            You don't have the required permissions to access this page.
          </p>
          
          {!user ? (
            <div className="space-y-3">
              <p className="text-sm text-amber-600 mb-4">
                You need to be logged in to access this feature.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button onClick={() => navigate("/login")} variant="default" className="flex items-center">
                  <LogIn className="mr-2 h-4 w-4" />
                  Log In
                </Button>
                <Button onClick={() => navigate("/")} variant="outline" className="flex items-center">
                  <Home className="mr-2 h-4 w-4" />
                  Return Home
                </Button>
              </div>
            </div>
          ) : (
            <div className="space-y-3">
              <div className="text-left bg-muted p-4 rounded-md mb-4">
                <p className="text-sm text-amber-600 font-medium mb-2">
                  Your account doesn't have permission to access this resource.
                </p>
                <p className="text-xs text-muted-foreground mb-1">Current user: {user.email}</p>
                <p className="text-xs text-muted-foreground">
                  Your roles: {userRoles.length > 0 ? userRoles.join(', ') : 'No roles assigned'}
                </p>
                <p className="text-xs text-muted-foreground mt-2">
                  Admin areas require the "admin" role. Please contact the site administrator if you need access.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button onClick={() => navigate("/courses")} variant="default" className="flex items-center">
                  <Home className="mr-2 h-4 w-4" />
                  Go to Courses
                </Button>
                <Button onClick={() => navigate(-1)} variant="outline" className="flex items-center">
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Go Back
                </Button>
                <Button onClick={signOut} variant="ghost" className="text-red-500 hover:text-red-700">
                  Sign Out
                </Button>
              </div>
            </div>
          )}
        </Card>
      </div>
    </Layout>
  );
};

export default Unauthorized;
